/**
 * Dominio proprio da imobiliaria (Feature #538).
 *
 * `www.imobiliariax.com.br` nao traz o slug no endereco, entao o site pergunta
 * ao back-end de quem e o host antes de montar a aplicacao (ver
 * `custom-host-bootstrap.tsx`). O resultado fica guardado aqui para que
 * `getTenantSlug()` continue sincrono — o router e o cliente HTTP dependem
 * disso.
 *
 * Sem imports de proposito: `host.ts` le este modulo, e o servico HTTP depende
 * de `host.ts`. Importar o servico daqui fecharia o ciclo.
 */

export interface CustomHostTenant {
  slug: string
  customDomain: string
}

let customHostTenant: CustomHostTenant | null = null

/** Dominio proprio READY da imobiliaria atual, visto pela rota publica. */
let knownCustomDomain: string | null = null

export function setCustomHostTenant(tenant: CustomHostTenant | null): void {
  customHostTenant = tenant
  if (tenant) knownCustomDomain = tenant.customDomain
}

/** Imobiliaria dona do host atual, quando o host e um dominio proprio. */
export function getCustomHostTenant(): CustomHostTenant | null {
  return customHostTenant
}

/**
 * Guarda o dominio proprio da imobiliaria aberta por subdominio ou caminho,
 * para o `rel=canonical` apontar para o endereco que ela divulga.
 */
export function setKnownCustomDomain(domain: string | null | undefined): void {
  knownCustomDomain = domain || null
}

export function getKnownCustomDomain(): string | null {
  return knownCustomDomain
}
